import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const BackButton = ({ onClick }) => (
  <motion.button
    onClick={onClick}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    className="absolute left-4 sm:left-6 top-6 sm:top-8 
               p-2.5 sm:p-3
               rounded-full bg-white/90 
               shadow-sm hover:shadow-md
               border border-amber-100/50
               hover:border-amber-200
               transition-all duration-200 
               cursor-pointer
               z-10"
  >
    <ArrowLeft className="w-5 h-5 sm:w-6 sm:h-6 text-amber-600 
                         transition-all duration-200
                         group-hover:text-amber-700" />
  </motion.button>
);

export default BackButton;